export default __webpack_public_path__ + "static/media/WHITTIER DISTRIC LOGO_outlined-02.68df98e6.jpg";